/**
 * Playful reminder shown to store-pickup customers: they get an SMS when the
 * order is ready and should not come to the shop before that notification.
 */
export function PickupSmsNotice({ className = "" }: { className?: string }) {
  return (
    <div
      className={`overflow-hidden rounded-2xl border-2 border-primary/40 bg-gradient-to-br from-primary/10 to-amber-100/60 p-3 ${className}`}
    >
      <p className="flex items-center gap-2 text-sm font-extrabold text-foreground">
        <span className="text-lg">📱🐼</span> Θα σου στείλουμε SMS μόλις είναι έτοιμη!
      </p>
      <p className="mt-1 text-sm font-medium text-foreground/80">
        Ο Panda ετοιμάζει την παραγγελία σου με μεράκι ✨ Μόλις είναι έτοιμη, θα λάβεις{" "}
        <strong>SMS ειδοποίηση</strong>. Σε παρακαλούμε{" "}
        <strong>μην έρθεις στο κατάστημα πριν λάβεις το μήνυμα</strong> — δεν θέλουμε να
        περιμένεις άδικα! 💛
      </p>
    </div>
  );
}
